import { apiSauceInstance } from '../../../services/api'

export const validacaoCarregamento = (id: string) => {
  return apiSauceInstance.get(`/programacoes/${id}/validacao`)
}
